import { api } from '../../lib/api';
import type { Pedido } from '../../types/orders';
import { normalizePedido } from './orderNormalizer';

interface RawOrderDetailsResponse {
  data?: unknown;
  orcamento?: unknown;
  orca?: unknown;
}

function extractOrderPayload(response: RawOrderDetailsResponse | unknown): unknown {
  if (!response || typeof response !== 'object') {
    return response;
  }

  const record = response as RawOrderDetailsResponse;
  return record.data ?? record.orcamento ?? record.orca ?? response;
}

export async function fetchOrderDetails(orcId: number): Promise<Pedido> {
  const response = (await api(`/orcamento/${orcId}`, {
    method: 'GET',
  })) as RawOrderDetailsResponse | unknown;

  const payload = extractOrderPayload(response);
  return normalizePedido(payload, { role: 'producao' });
}
